import { Button, ResponsiveDrawer, strIsNullOrEmpty, Typography } from '@fox/atoms';
import { FlexColumnSpaced } from '@fox/layout';
import * as moment from 'moment';
import { useState } from 'react';

/**perhaps when we expand on ticket functionality, we can add something like this back in */
// function RsvpPopoverOverlay({
// 	eventId,
// 	refetch,
// 	rsvp,
// 	rsvpOptions,
// 	rsvpStatus,
// 	setUpdatedRsvp
// }: {
// 	rsvpStatus: string;
// 	eventId: string;
// 	refetch: () => void;
// 	rsvpOptions: SwiftFoxRsvpOption[];
// 	setUpdatedRsvp?: (rsvp: string) => void;
// 	rsvp: (model: UpdateRsvpStatusInputModel) => Promise<boolean>;
// }) {
// 	const { contentId } = useContentContext();
// 	const [selectedRsvpId, setSelectedRsvpId] = useState<string>(rsvpStatus);
// 	const { closePopover } = usePopoverContext();
// 	return (
// 		<FlexColumnSpaced style={{ minWidth: '300px' }}>
// 			<Padded>
// 				<MuiRadioGroup value={selectedRsvpId} onChange={(_, value) => setSelectedRsvpId(value)}>
// 					{rsvpOptions?.map(option => {
// 						return (
// 							<FormRadio key={option.id} value={option.id}>
// 								{option.displayName}
// 							</FormRadio>
// 						);
// 					})}
// 					<FormRadio value="cancel">Cancel RSVP</FormRadio>
// 				</MuiRadioGroup>
// 				<Flex style={{ justifyContent: 'space-between' }}>
// 					<Button
// 						disabled={!selectedRsvpId}
// 						variant="primary"
// 						onClick={async () => {
// 							const isCancel = selectedRsvpId === 'cancel';
// 							const result = await rsvp({
// 								contentId,
// 								eventId,
// 								rsvpOptionId: isCancel ? null : selectedRsvpId
// 							});
// 							if (result === true) {
// 								refetch();
// 								setUpdatedRsvp?.(isCancel ? null : selectedRsvpId);
// 								closePopover();
// 							}
// 						}}
// 					>
// 						Confirm
// 					</Button>
// 					<Button onClick={() => closePopover()} variant="tertiary">
// 						Cancel
// 					</Button>
// 				</Flex>
// 			</Padded>
// 		</FlexColumnSpaced>
// 	);
// }

function DesktopRsvpButton({
	refetch,
	rsvpFormLink,
	availableTickets,
	eventStart
}: {
	refetch: () => void;
	availableTickets?: number;
	rsvpFormLink?: string;
	eventStart: Date;
}) {
	const [open, setOpen] = useState<boolean>(false);

	if (moment(eventStart).isBefore(moment())) {
		return <Typography>Past event</Typography>;
	}
	if (availableTickets !== null && availableTickets < 1) {
		return <Typography>No tickets available</Typography>;
	}

	return (
		<>
			<Button onClick={() => setOpen(true)} variant="secondary">
				RSVP
			</Button>
			<ResponsiveDrawer
				placement="right"
				title={'RSVP to Event'}
				width={800}
				destroyOnClose
				open={open}
				onClose={() => {
					setOpen(false);
					refetch();
				}}
			>
				<div style={{ display: 'flex', height: '100%' }}>
					<iframe style={{ padding: '1rem', border: '0px', flexGrow: 1 }} width={800} src={rsvpFormLink}></iframe>
				</div>
			</ResponsiveDrawer>
		</>
	);
}

function MobileRsvpButton({
	refetch,
	rsvpFormLink,
	availableTickets,
	eventStart
}: {
	eventStart: Date;
	eventId: string;
	refetch: () => void;
	availableTickets?: number;
	rsvpFormLink?: string;
}) {
	const [open, setOpen] = useState<boolean>(false);

	if (moment(eventStart).isBefore(moment())) {
		return <div></div>;
	}
	if (availableTickets !== null && availableTickets < 1) {
		return <div></div>;
	}

	return (
		<div>
			<Button onClick={() => setOpen(true)} variant="secondary">
				RSVP
			</Button>

			<ResponsiveDrawer
				placement="bottom"
				title="Rsvp to event"
				width="100%"
				height="100%"
				style={{ height: '100%' }}
				destroyOnClose
				open={open}
				onClose={() => {
					setOpen(false);
					refetch?.();
				}}
			>
				<div style={{ display: 'flex', height: '100%' }}>
					<iframe style={{ padding: '1rem', border: '0px', flexGrow: 1 }} width="100%" src={rsvpFormLink}></iframe>
				</div>
			</ResponsiveDrawer>
		</div>
	);
}

export function RsvpButton({
	eventStart,
	eventId,
	refetch,
	isMobile,
	rsvpFormLink,
	availableTickets
}: {
	eventStart: Date;
	eventId: string;
	refetch: () => void;
	isMobile: boolean;
	availableTickets?: number;
	rsvpFormLink?: string;
}) {
	return (
		<FlexColumnSpaced onClick={e => e.stopPropagation()} style={{ width: 'max-content' }}>
			{isMobile ? (
				<MobileRsvpButton
					eventId={eventId}
					refetch={refetch}
					rsvpFormLink={rsvpFormLink}
					availableTickets={availableTickets}
					eventStart={eventStart}
				/>
			) : (
				<DesktopRsvpButton
					eventStart={eventStart}
					refetch={refetch}
					rsvpFormLink={rsvpFormLink}
					availableTickets={availableTickets}
				/>
			)}
		</FlexColumnSpaced>
	);
}
